import {
    autocompleteFieldConstructor,
    dropdownFieldConfigConstructor,
    rangeFieldConfigConstructor,
    switchFieldConstructor,
    switchWithAutoCompleteFieldConfigConstructor,
    switchWithSelectFieldConstructor,
} from "scenes/cohort-filters/filter-configs/fieldContructors";
import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { nestedFieldConstructor } from "scenes/cohort-filters/filter-configs/fieldContructors/nestedField";

const bloodCountChange = [
    "LEUKOCYTE_INCREASE",
    "LEUKOCYTE_REDUCTION",
    "ANAMIE",
    "INCREASE_IN_HEMATOCRIT",
    "INCREASE_IN_PLATELETS",
    "REDUCTION_IN_PLATELETS",
].map((value) => ({
    value,
    label: `anamnesis.hematology.${value}`,
}));

export const hematologyFields = {
    ...switchFieldConstructor({
        category: Category.HEMATOLOGY,
        pathToValue: "anamnesis.haveHematoFamilialSyndromOrGenetic",
        label: "anamnesis.hematology.haveHematoFamilialSyndromOrGenetic",
    }),
    ...switchWithAutoCompleteFieldConfigConstructor({
        category: Category.HEMATOLOGY,
        pathToSelectValues: "anamnesis.haveActiveHematoDiseaseData.values.value",
        pathToSwitchQuestion: "anamnesis.haveActiveHematoDisease",
        autocompleteLabel: "anamnesis.hematology.what-kind",
        fieldLabel: "anamnesis.hematology.haveActiveHematoDisease",
    }),
    ...switchWithAutoCompleteFieldConfigConstructor({
        category: Category.HEMATOLOGY,
        pathToSelectValues: "anamnesis.haveFormerHematoDiseaseData.values.value",
        pathToSwitchQuestion: "anamnesis.haveFormerHematoDisease",
        autocompleteLabel: "anamnesis.hematology.what-kind",
        fieldLabel: "anamnesis.hematology.haveFormerHematoDisease",
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.HEMATOLOGY,
        pathToSwitchQuestion: "anamnesis.havePreviousChangeInBloodCount",
        pathToSelectValue: "anamnesis.havePreviousChangeInBloodCountData.values.value",
        nestedPathToSelectValue: "anamnesis.havePreviousChangeInBloodCountData.values",
        label: "anamnesis.hematology.havePreviousChangeInBloodCount",
        selectOptions: bloodCountChange,
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.HEMATOLOGY,
        pathToSwitchQuestion: "anamnesis.haveCurrentChangeInBloodCount",
        pathToSelectValue: "anamnesis.haveCurrentChangeInBloodCountData.values.value",
        selectOptions: bloodCountChange,
        label: "anamnesis.hematology.haveCurrentChangeInBloodCount",
        nestedPathToSelectValue: "anamnesis.haveCurrentChangeInBloodCountData.values",
    }),
    ...switchWithAutoCompleteFieldConfigConstructor({
        category: Category.HEMATOLOGY,
        pathToSelectValues: "anamnesis.haveAbdomenUltrasoundData.values.value",
        pathToSwitchQuestion: "anamnesis.haveAbdomenUltrasound",
        autocompleteLabel: "anamnesis.hematology.spleen-size-reported",
        fieldLabel: "anamnesis.hematology.spleenExamination",
    }),
    ...switchFieldConstructor({
        category: Category.HEMATOLOGY,
        pathToValue: "anamnesis.haveBoneMarrowPunctured",
        label: "anamnesis.hematology.haveBoneMarrowPuncturedQuestion",
    }),
    ...nestedFieldConstructor({
        category: Category.HEMATOLOGY,
        label: "Bone marrow biopsy",
        nestedPath: "anamnesis.haveBoneMarrowPuncturedData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedHaveBoneMarrowPunctured$anamnesis.haveBoneMarrowPunctured",
            }),
            rangeFieldConfigConstructor({
                nestedComponent: true,
                pathToValue: "anamnesis.haveBoneMarrowPuncturedData.values.date",
                label: "Date",
                fieldWidth: 100,
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.haveBoneMarrowPuncturedData.values.cellularity",
                label: "anamnesis.hematology.cellularity",
                nestedComponent: true,
                dropdownValues: Object.freeze(["Hyper", "Normo", "Hypocellular"]),
                fieldWidth: 150,
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.haveBoneMarrowPuncturedData.values.fibrosis",
                label: "anamnesis.hematology.degree-of-fibrosis",
                nestedComponent: true,
                dropdownValues: Object.freeze(["0", "1", "2", "3", "4"]),
                fieldWidth: 150,
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.haveBoneMarrowPuncturedData.values.dysplasia",
                label: "anamnesis.hematology.signs-of-dysplasia",
                fieldWidth: 150,
                nestedComponent: true,
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.haveBoneMarrowPuncturedData.values.atypical",
                label: "anamnesis.hematology.atypical-cells",
                fieldWidth: 150,
                nestedComponent: true,
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.haveBoneMarrowPuncturedData.values.blastCount",
                label: "anamnesis.hematology.blast-count",
                fieldWidth: 150,
                nestedComponent: true,
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.haveBoneMarrowPuncturedData.values.abnormalities",
                label: "anamnesis.hematology.other-abnormalities",
                fieldWidth: 150,
                nestedComponent: true,
            }),
        ],
    }),
    ...switchFieldConstructor({
        category: Category.HEMATOLOGY,
        pathToValue: "tags",
        label: "CCUS",
        getValue: (value) => value === "CCUS?",
        setValue: (eventTargetValue) => (eventTargetValue ? "CCUS?" : "!CCUS?"),
        explicitFieldType: 'string',
        mustNotOnBang: true
    }),
};
